export default __webpack_public_path__ + "static/media/SouthAmerica_03.054b2d55.png";